import React, { useEffect, useMemo, useState } from 'react';
import "../../assets/chatbotconfig.css";
import IntentSection from '../IntentSection/index';
import MandetoryQue from '../MandetoryQue/index';
import PropertyInfo from '../PropertyInfo/index';
import { AlternatePublishConfig, getAdminPreviewToken, getConfigByID, getCSBEProperty, PublishConfig } from '../../Services/chatbot';
import { toast } from 'react-toastify';
import { getSetting } from '../../../settings';
import ReservationConfig from '../ReservationConfig/index';
import WidgetCustomization from '../WidgetCustomization/index';
import ChatHistory from '../ChatHistory/index';
import DeleteModal from '../DeleteModal/index';
import PublishModal from '../PublishModal/index';
import { Button, Modal } from "../../../evo/bootstrap";
import DocumentManage from '../DocumentManage/index';
import ScriptComponent from '../ScriptComponent/index';
import Publish from '../Publish/index';
import PublishButton from '../PublishButton/index';
import PublishReminder from '../PublishReminder/index';
import InfoImage from '../InfoImage/index';
import DesktopNav from '../DesktopNav/index';
import MobileNavDropdown from '../MobileNavDropdown/index';
import NewChatHistory from '../NewChatHistory';
import SessionChatHistory from '../SessionChatHistory/index';
import FeatureFeedback from '../FeatureFeedback/index';
import TokenAnalytics from '../TokenAnalytics/index';
import AgentSetup from '../AgentSetup/index';
import { KnowledgeSources } from '../../../components/KnowledgeSources';
import { BotMessageSquare } from 'lucide-react';
import { AdminLoader } from '../../../components/admin/AdminLoader';
import "../../assets/evo-theme.css";

const decStr = (decString) => {
    const getRandomNum = parseInt(decString.slice(0, 2), 10);
    const position = parseInt(decString.slice(2, 3), 10);
    let strObj = decString.slice(3);

    const l = Math.floor(position + (getRandomNum / 2));

    strObj = strObj.slice(0, position) + strObj.slice(l);

    try {
        const decodedData = atob(strObj); // Base64 decode
        return decodedData;
    } catch (e) {
        console.error("Decoding failed:", e);
        return null;
    }
}

const ChatbotFAQ = ({ propertyId: hostPropertyId = null, groupId: hostGroupId = null, evoResolved = false, defaultPropertyName = null, user = { userId: "", roleId: "", customerName: "" }, onDirtyChange }: any) => {
    const [configData, setConfigData] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [publishError, setPublishError] = useState("");
    const [publishing, setPublishing] = useState(false);
    const [isDirty, setIsDirty] = useState(false)
    const [confirmModal, setConfirmModal] = useState<any>({
        show: false,
        id: null,
        label: '',
        onConfirm: null,
    });
    const [csbepropertydata, setcsbepropertydata] = useState<any>(null);
    // Whether this chatbot is backed by a STAAH/CSBE property. Evo chatbots that
    // are not carry no booking engine, so the booking and contact details CSBE
    // would have supplied are optional for them.
    const [csbeLinked, setCsbeLinked] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [groupData, setGroupData] = useState<any>(null)
    const [isGroup, setIsGroup] = useState(false)
    const [showPreviewErrorModal, setShowPreviewErrorModal] = useState(false);
    const [resolvedPropertyId, setResolvedPropertyId] = useState<any>(null)
    const [propertyId, setpropertyId] = useState<any>(null)
    const [groupId, setgroupId] = useState<any>(null)
    const [tokenError, setTokenError] = useState("");
    const [shouldLoadChatHistory, setShouldLoadChatHistory] = useState(false);
    const [shouldLoadQna, setShouldLoadQna] = useState(false)
    const [shouldLoadIntent, setShouldLoadIntent] = useState(false)
    const [activeTab, setActiveTab] = useState("property");
    const [isNeedPublish, setIsNeedPublish] = useState(false)
    const [showPublishReminder, setShowPublishReminder] = useState(false);
    const [publishTrigger, setPublishTrigger] = useState(0);
    const [showInfoImage, setShowInfoImage] = useState(false)
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
    const [buttonName,setButtonName]=useState("")
    const [widgetKeyModal, setWidgetKeyModal] = useState<any>({ show: false, rawKey: "" });
    const [previewReloadKey, setPreviewReloadKey] = useState(0);
    const parentUserContext = user;


    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // The Evo host owns the page, so unsaved changes are reported to it instead of
    // guarding `beforeunload` ourselves.
    useEffect(() => {
        onDirtyChange?.(isDirty);
    }, [isDirty, onDirtyChange])

    // new handleTabChange: supports an optional onSuccess callback

    // const handleTabChange = (newTab, e, onSuccess) => {
    //     if (e?.preventDefault) e.preventDefault();
    //     if (newTab === activeTab) return false;

    //     if (isDirty) {
    //         const confirmLeave = window.confirm(
    //             "You have unsaved changes. Are you sure you want to leave this tab?"
    //         );
    //         if (!confirmLeave) return false; // ❌ block navigation

    //         setIsDirty(false); // ✅ discard changes
    //     }

    //     setActiveTab(newTab);
    //     if (typeof onSuccess === "function") onSuccess();
    //     return true; // ✅ navigation allowed
    // };
    useEffect(() => {
        if (publishTrigger > 0) { // only run after first trigger
            setShowPublishReminder(true);

            const timer = setTimeout(() => {
                setShowPublishReminder(false);
            }, 15000);

            return () => clearTimeout(timer);
        }
    }, [publishTrigger]);


    const handleTabChange = (newTab, e, onSuccess) => {
        if (e?.preventDefault) e.preventDefault();
        if (newTab === activeTab) return false;

        if (isDirty) {
            // Instead of window.confirm → open modal
            setConfirmModal({
                show: true,
                title: "Unsaved Changes",
                label: "You have unsaved changes. Do you want to leave this tab without saving?",
                confirmText: "Yes, Leave",
                cancelText: "Stay",
                onConfirm: () => {
                    setIsDirty(false);       // ✅ Discard changes
                    setActiveTab(newTab);    // ✅ Move to new tab
                    if (typeof onSuccess === "function") onSuccess();
                    setConfirmModal(prev => ({ ...prev, show: false }));
                },
                onClose: () => {
                    // ❌ Stay on current tab
                    setConfirmModal(prev => ({ ...prev, show: false }));
                }
            });
            return false;
        }

        // No unsaved changes → just switch
        setActiveTab(newTab);
        if (typeof onSuccess === "function") onSuccess();
        return true;
    };




    // Identity comes from the Evo host: the property/group the user opened the MFE
    // for is passed in as parameters, and the access token is attached per-request
    // by the BFF proxy backend (see src/evo/backend.ts).
    useEffect(() => {
        if (!hostPropertyId && !hostGroupId) {
            setTokenError("No property selected. Open SwiftAssist from a property in Evo.");
            setLoading(false);
            return;
        }

        setTokenError("");
        setErrorMessage("");
        setpropertyId(hostPropertyId || null);
        setgroupId(hostGroupId || null);
        setResolvedPropertyId(hostPropertyId || hostGroupId);
    }, [hostPropertyId, hostGroupId]);

    // useEffect(() => {
    //     if (propertyId || groupId) {
    //         getPropertyData();
    //     }
    // }, [propertyId, groupId]);



    // useEffect(() => {
    //     if (!resolvedPropertyId) return;

    //     setLoading(true);

    //     // Remove old script and CSS
    //     document.querySelectorAll(`script[src*="ai_booking_ws_new.js"]`).forEach(el => el.remove());
    //     document.querySelectorAll(`link[href*="ai_booking.css"]`).forEach(el => el.remove());

    //     // Inject fresh chatbot script with cache-buster
    //     const script = document.createElement("script");
    //     script.src = `https://hotelbot.chatobi.ai/ai_booking_ws_new.js?propertyId=${resolvedPropertyId}&t=${Date.now()}`;
    //     script.defer = true;
    //     document.body.appendChild(script);

    //     script.onload = () => setLoading(false);
    //     script.onerror = () => {
    //         console.error("Failed to load chatbot plugin.");
    //         setLoading(false);
    //     };
    // }, [resolvedPropertyId]);

    // useEffect(() => {
    //     const init = async () => {
    //         if (!resolvedPropertyId) return;

    //         setLoading(true);

    //         try {
    //             // 1️⃣ Load property & config data
    //             await getPropertyData();

    //             // 2️⃣ Load chatbot script
    //             await new Promise<void>((resolve, reject) => {
    //                 const script = document.createElement("script");
    //                 script.src = `https://hotelbot.chatobi.ai/ai_booking_ws_new.js?propertyId=${resolvedPropertyId}&t=${Date.now()}`;
    //                 script.defer = true;
    //                 document.body.appendChild(script);
    //                 script.onload = resolve;
    //                 script.onerror = () => reject(new Error("Failed to load chatbot plugin"));
    //             });

    //         } catch (err) {
    //             console.error(err);
    //         } finally {
    //             // ✅ Only here do we mark loading as false
    //             setLoading(false);
    //         }
    //     };

    //     init();
    // }, [resolvedPropertyId]);

    // Helper function to cleanup chatbot global state
    const cleanupChatbot = () => {
        // Remove old chatbot script and CSS elements
        document.querySelectorAll(`script[src*="hotel-chatbot.iife.js"]`).forEach(el => el.remove());
        document.querySelectorAll(`script[src*="ai_booking_ws_new.js"]`).forEach(el => el.remove());
        document.querySelectorAll(`link[href*="ai_booking.css"]`).forEach(el => el.remove());
        
        // Clear potential global variables that the chatbot script might have set
        // These are common patterns used by chatbot scripts
        const globalVarsToClean = [
            'chatbot', 'Chatbot', 'CHATBOT',
            'aiBooking', 'AI_BOOKING', 'AiBooking',
            'hotelBot', 'HotelBot', 'HOTELBOT',
            'chatWidget', 'ChatWidget', 'CHAT_WIDGET',
            'botInstance', 'BotInstance',
            'websocket', 'ws', 'socket',
            'chatbotConfig', 'chatbotInstance',
            'propertyId', 'PROPERTY_ID'
        ];
        
        globalVarsToClean.forEach(varName => {
            if (window[varName] !== undefined) {
                try {
                    // Try to call destroy/cleanup method if it exists
                    if (typeof window[varName]?.destroy === 'function') {
                        window[varName].destroy();
                    }
                    if (typeof window[varName]?.cleanup === 'function') {
                        window[varName].cleanup();
                    }
                    if (typeof window[varName]?.disconnect === 'function') {
                        window[varName].disconnect();
                    }
                    if (typeof window[varName]?.close === 'function') {
                        window[varName].close();
                    }
                    delete window[varName];
                } catch (e) {
                    console.warn(`Failed to cleanup global var ${varName}:`, e);
                }
            }
        });
        
        // Clear any chatbot-related items from sessionStorage (except authToken)
        const keysToRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && (key.includes('chatbot') || key.includes('chat_') || key.includes('bot_') || key.includes('thread'))) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => sessionStorage.removeItem(key));

        // Remove chatbot DOM container injected by hotel-chatbot.iife.js
        const chatbotContainer = document.getElementById('hotel-chatbot-container');
        if (chatbotContainer) chatbotContainer.remove();
    };

    useEffect(() => {
        // Use a flag to track if this effect has been cancelled (property changed)
        let isCancelled = false;

        const init = async () => {
            if (!resolvedPropertyId) return;

            setLoading(true);

            try {
                // 0️⃣ Comprehensive cleanup of old chatbot before loading new one
                cleanupChatbot();

                // Check if cancelled before proceeding
                if (isCancelled) return;

                // 1️⃣ Load property & config data
                await getPropertyData();

                // Check if cancelled after async operation
                if (isCancelled) return;

                // 2️⃣ Fetch an admin preview token so the widget can authenticate
                //    without needing the raw widget key
                let previewToken = "";
                try {
                    const tokenRes = await getAdminPreviewToken(resolvedPropertyId);
                    if (tokenRes.status === 200 && tokenRes.data?.token) {
                        previewToken = tokenRes.data.token;
                    }
                } catch (tokenErr) {
                    console.warn("Could not fetch admin preview token — chatbot may not authenticate:", tokenErr);
                }

                if (isCancelled) return;

                // 3️⃣ Load chatbot JS (await this so init happens after JS is ready)
                await new Promise<void>((resolve, reject) => {
                    // Check if cancelled before creating script
                    if (isCancelled) {
                        resolve();
                        return;
                    }
                    
                    const script = document.createElement("script");
                    let srcUrl = `${getSetting('chatbotBaseUrl')}/hotel-chatbot.iife.js?hotelId=${encodeURIComponent(resolvedPropertyId)}&t=${Date.now()}`;
                    if (previewToken) {
                        srcUrl += `&token=${encodeURIComponent(previewToken)}`;
                    }
                    script.src = srcUrl;
                    script.defer = true;
                    
                    // Only add to DOM if not cancelled
                    if (!isCancelled) {
                        document.body.appendChild(script);
                        script.onload = () => {
                            // If cancelled after script loaded, remove it immediately
                            if (isCancelled) {
                                script.remove();
                            }
                            resolve();
                        };
                        script.onerror = () => reject(new Error("Failed to load chatbot plugin"));
                    } else {
                        resolve();
                    }
                });

            } catch (err) {
                if (!isCancelled) {
                    console.error(err);
                }
            } finally {
                if (!isCancelled) {
                    setLoading(false);
                }
            }
        };

        init();

        // Cleanup function: runs when resolvedPropertyId changes or component unmounts
        return () => {
            isCancelled = true;
            // Also run cleanup when effect is cancelled
            cleanupChatbot();
        };
    }, [resolvedPropertyId, previewReloadKey]);

    // CSS in chatbotconfig.css disables pointer-events on the widget tree
    // and re-enables them on interactive elements (cards, FAB, etc.).
    // When the chat window opens (.chat-header appears), we need to
    // dynamically enable pointer-events on the chat window container
    // so the user can interact with the chat preview.
    useEffect(() => {
        const patchChatWindow = () => {
            const chatHeader = document.querySelector('#hotel-chatbot-container .chat-header');
            if (chatHeader && chatHeader.parentElement) {
                chatHeader.parentElement.style.setProperty('pointer-events', 'auto', 'important');
            }
        };

        const observer = new MutationObserver(patchChatWindow);
        observer.observe(document.body, { childList: true, subtree: true });
        patchChatWindow();

        return () => observer.disconnect();
    }, []);

    const loadInitialData = async () => {
        try {
            const res = await getConfigByID();
            setConfigData(res.data);
        } catch (error) {
            if (error.status === 401) {
                setTokenError("Access denied. Please verify using a valid link.")
            }
            console.error("Failed to load config:", error);
            // toast.error(error.message)
        }
        //finally {
        //     setLoading(false);
        // }
    };

    const confirmPublish = async () => {
        const decryptedPropertyId = resolvedPropertyId ? decStr(resolvedPropertyId) : null;
        const decryptedGroupId = groupId ? decStr(groupId) : null;
        //console.log("resolved property id ",decryptedPropertyId)
        setShowPublishReminder(false)
        setLoading(true);
        try {
            const res = await getConfigByID();
            if (res.status === 200 && res.data) {
                const publishRes = await AlternatePublishConfig(resolvedPropertyId);
                if (publishRes.status === 200) {

                    //toast.success(publishRes.data?.message || "Configuration published!");
                    toast.success(publishRes.data?.message || "Configuration published!", {
                        autoClose: 500
                    });

                    setIsNeedPublish(false);
                    //  setComponentKey(prev => prev + 1);
                    setLoading(false);
                    setPreviewReloadKey((key) => key + 1);
                    // 
                    // ✅ reset dirty after publish
                } else {
                    toast.error(publishRes.data?.message || "Failed to publish.");
                }
            } else {
                setPublishError("Please fill data before publishing.");
            }
        } catch (error) {
            if (error.status === 401) {
                setTokenError("Access denied. Please verify using a valid link.")
            }
            console.error("Failed to load config:", error);
            setTokenError(error.message)
        } finally {
            setLoading(false);
        }
    };

    // const loadPlugin = () => {
    //     if (!configData?.property_details?.property_name) {
    //         setShowPreviewErrorModal(true); // Show modal
    //         return;
    //     }
    //     if (!canPreview) {
    //         toast.warning("Preview not available due to missing configuration.");
    //         return;
    //     }
    //     // Set a flag in sessionStorage before reload
    //     sessionStorage.setItem("loadPluginAfterReload", "true");
    //     // Reload the page
    //     window.location.reload();
    // };


    const getPropertyData = async () => {
        let res;
        try {
            const queryParams: Record<string, any> = {};
            setErrorMessage("");
            const decryptedPropertyId = propertyId ? decStr(propertyId) : null;
            const decryptedGroupId = groupId ? decStr(groupId) : null;
            if (propertyId) queryParams["PropertyId"] = propertyId;
            if (groupId) queryParams["GroupId"] = groupId;
            queryParams["DeviceInfo"] = "Y";
            setIsGroup(!!groupId && !propertyId);
            res = await getCSBEProperty(queryParams);

            if (res.status === 200 && res.data) {

                setcsbepropertydata(res.data?.PropertyList?.[decryptedPropertyId]?.PropertyData);
                setCsbeLinked(true);
                if (res.data?.GroupProperty === true) {
                    setGroupData(res.data?.PropertyList);
                    //setIsGroup(res.data?.GroupProperty)
                }

                loadInitialData();
            } else if (evoResolved) {
                // An organisation whose property has no STAAH record yet still gets the
                // configuration panel, blank apart from the name of its Evo subscription.
                setcsbepropertydata(defaultPropertyName ? { PropertyName: defaultPropertyName } : null);
                setCsbeLinked(false);
                loadInitialData();
            } else {
                console.error(`Unexpected response status: ${res.status}`, res);
                setErrorMessage(res.data.message)
            }
        } catch (error) {
            if (error.status === 401) {
                setTokenError("Access denied. Please verify using a valid link.")
                return;
            }
            console.error("Failed to load config:", error);
            if (evoResolved) {
                setcsbepropertydata(defaultPropertyName ? { PropertyName: defaultPropertyName } : null);
                setCsbeLinked(false);
                loadInitialData();
                return;
            }
            setErrorMessage(error.message)

        }
    };

    return (

        <>
            {
                    (
                        <>
                            {
                                tokenError ?
                                    (
                                        <>
                                            <div className="">
                                                <h3>Error</h3>
                                                <h6>{tokenError}</h6>
                                            </div>
                                        </>
                                    ) : errorMessage ? (
                                        <>
                                            <div className="">
                                                <h3>404 - Not found</h3>
                                                <h6>{errorMessage}</h6>
                                            </div>
                                        </>
                                    ) :
                                        (
                                            <>
                                                <div className='qnawrapper evo-admin'>
                                                    <header data-slot="page-header" className={`flex items-center gap-3 border-b border-border pb-4 pt-2 ${publishing ? 'blurred' : ''}`}>
                                                        <div data-slot="page-header-icon" className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-secondary text-primary [&_svg]:size-5" aria-hidden="true">
                                                            <BotMessageSquare />
                                                        </div>
                                                        <div className='min-w-0'>
                                                            <div data-slot="page-header-title" className="flex items-center gap-2">
                                                                <h2 data-slot="page-title" className="truncate text-lg font-semibold leading-7 text-foreground">
                                                                    {configData?.property_details?.property_name || csbepropertydata?.PropertyName || "Chatbot FAQ"}
                                                                </h2>
                                                                {parentUserContext.userId && parentUserContext.customerName && (
                                                                    <FeatureFeedback feature="SwiftAssist" customerName={parentUserContext.customerName} userId={parentUserContext.userId} roleId={parentUserContext.roleId} />
                                                                )}
                                                            </div>
                                                            <div className="text-sm text-muted-foreground">Configure your chatbot's content, look and behaviour</div>
                                                        </div>
                                                    </header>
                                                    <div data-slot="admin-body" className="relative py-4">
                                                        <div className="card-container position-relative">
                                                            {publishing && (
                                                                <AdminLoader />
                                                            )}

                                                            {/* <div className={`rounded-4 border-0 ${publishing ? 'blurred' : ''}`}> */}
                                                            <div className="card-body p-0">
                                                                {
                                                                    loading ? (
                                                                        <AdminLoader />
                                                                    ) : (
                                                                        <>
                                                                            <div data-slot="admin-layout" className={isDesktop ? 'flex items-start gap-6' : 'flex flex-col gap-4'}>
                                                                                {
                                                                                    isDesktop ? (
                                                                                        <DesktopNav activeTab={activeTab} handleTabChange={handleTabChange}
                                                                                            setShouldLoadIntent={setShouldLoadIntent} setShouldLoadQna={setShouldLoadQna} setShouldLoadChatHistory={setShouldLoadChatHistory}
                                                                                            isNeedPublish={isNeedPublish}
                                                                                            setConfirmModal={setConfirmModal}
                                                                                            confirmPublish={confirmPublish}
                                                                                            setActiveTab={setActiveTab}
                                                                                        />
                                                                                    ) : (
                                                                                        <MobileNavDropdown
                                                                                            activeTab={activeTab}
                                                                                            handleTabChange={handleTabChange}
                                                                                            setShouldLoadIntent={setShouldLoadIntent}
                                                                                            setShouldLoadQna={setShouldLoadQna}
                                                                                            setShouldLoadChatHistory={setShouldLoadChatHistory}
                                                                                            isNeedPublish={isNeedPublish}
                                                                                            setConfirmModal={setConfirmModal}
                                                                                            confirmPublish={confirmPublish}
                                                                                            setActiveTab={setActiveTab}
                                                                                        />
                                                                                    )
                                                                                }



                                                                                <div className="tab-content nav-chat" id="pills-tabContent">
                                                                                    <div className={`tab-pane fade ${activeTab === "property" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "property" && (
                                                                                                <PropertyInfo key={JSON.stringify(configData)} propertyId={resolvedPropertyId} data={configData?.property_details}
                                                                                                    reservationData={configData?.Reservation} contactData={configData?.ContactUs} agentData={configData?.TalkToAgent} cancelData={configData?.CancelModify} keyTopics={configData?.KeyTopics}
                                                                                                    loadInitialData={loadInitialData} csbepropertydata={csbepropertydata} csbeLinked={csbeLinked} groupData={groupData} isGroup={isGroup}
                                                                                                    isDirty={isDirty} setIsDirty={setIsDirty} setIsNeedPublish={setIsNeedPublish} setPublishTrigger={setPublishTrigger}
                                                                                                    setShowInfoImage={setShowInfoImage} showInfoImage={showInfoImage}   setButtonName={setButtonName}
                                                                                                    onWidgetKeyGenerated={(rawKey) => setWidgetKeyModal({ show: true, rawKey })} />
                                                                                            )
                                                                                        }
                                                                                    </div>

                                                                                    <div className={`tab-pane fade ${activeTab === "faq" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "faq" && (
                                                                                                <MandetoryQue propertyId={resolvedPropertyId} setConfirmModal={setConfirmModal}
                                                                                                    isDirty={isDirty} setIsDirty={setIsDirty} onLoaded={(flag = false) => setShouldLoadQna(flag)}
                                                                                                    shouldLoadQna={shouldLoadQna} setIsNeedPublish={setIsNeedPublish} setPublishTrigger={setPublishTrigger}
                                                                                                />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    <div className={`tab-pane fade ${activeTab === "keytopic" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "keytopic" && (
                                                                                                <IntentSection setPublishModal={setConfirmModal} propertyID={resolvedPropertyId} isDirty={isDirty} setIsNeedPublish={setIsNeedPublish}
                                                                                                    setIsDirty={setIsDirty} onLoaded={() => setShouldLoadIntent(false)} shouldLoadIntent={shouldLoadIntent} setPublishTrigger={setPublishTrigger}
                                                                                                    menuRecords={{ reservation: configData?.Reservation, contact_us: configData?.ContactUs, talk_to_agent: configData?.TalkToAgent, cancel_modify_booking: configData?.CancelModify }}
                                                                                                    onTopicsChanged={loadInitialData} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    <div className={`tab-pane fade ${activeTab === "new_history" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "new_history" && (
                                                                                                //<ChatHistory setPublishModal={setConfirmModal} setPublishTrigger={setPublishTrigger} propertyID={resolvedPropertyId} isDirty={isDirty} setIsDirty={setIsDirty} onLoaded={() => setShouldLoadChatHistory(false)} shouldLoadChatHistory={shouldLoadChatHistory} setIsNeedPublish={setIsNeedPublish} />
                                                                                                <NewChatHistory propertyId={resolvedPropertyId} setIsDirty={setIsDirty} isDirty={isDirty} setConfirmModal={setConfirmModal}/>
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    {/* <div className={`tab-pane fade ${activeTab === "history" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "history" && (
                                                                                                <ChatHistory setPublishModal={setConfirmModal} setPublishTrigger={setPublishTrigger} propertyID={resolvedPropertyId} isDirty={isDirty} setIsDirty={setIsDirty} onLoaded={() => setShouldLoadChatHistory(false)} shouldLoadChatHistory={shouldLoadChatHistory} setIsNeedPublish={setIsNeedPublish} />
                                                                                            )
                                                                                        }

                                                                                    </div> */}
                                                                                    <div className={`tab-pane fade ${activeTab === "session_history" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "session_history" && (
                                                                                                <SessionChatHistory setIsNeedPublish={setIsNeedPublish} setPublishTrigger={setPublishTrigger} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    <div className={`tab-pane fade ${activeTab === "analytics" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "analytics" && (
                                                                                                <TokenAnalytics propertyId={resolvedPropertyId} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    <div className={`tab-pane fade ${activeTab === "chattheme" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "chattheme" && (
                                                                                                <WidgetCustomization setPublishTrigger={setPublishTrigger} loadInitialData={loadInitialData} data={configData?.property_details} isDirty={isDirty} setIsDirty={setIsDirty} setIsNeedPublish={setIsNeedPublish} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    {activeTab === "knowledge" && (
                                                                                        <KnowledgeSources key={resolvedPropertyId} onDirtyChange={setIsDirty} />
                                                                                    )}
                                                                                    <div className={`tab-pane fade ${activeTab === "scriptshow" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "scriptshow" && (
                                                                                                <ScriptComponent propertyId={resolvedPropertyId} hasWidgetKey={!!configData?.property_details?.widget_key_hash} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                    <div className={`tab-pane fade ${activeTab === "agent_setup" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "agent_setup" && (
                                                                                                <AgentSetup propertyId={resolvedPropertyId} isDirty={isDirty} setIsDirty={setIsDirty} setIsNeedPublish={setIsNeedPublish} setPublishTrigger={setPublishTrigger} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                   
                                                                                    <div className={`tab-pane fade ${activeTab === "publish" ? "show active" : ""}`}>
                                                                                        {
                                                                                            activeTab === "publish" && (
                                                                                                <Publish resolvedPropertyId={resolvedPropertyId} setIsNeedPublish={setIsNeedPublish} isNeedPublish={isNeedPublish} />
                                                                                            )
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                            }
                            <div id="div_plugin" className='ai-chatbot'></div>
                            <PublishModal
                                show={confirmModal.show}
                                title={confirmModal.title}
                                label={confirmModal.label}
                                onClose={confirmModal.onClose}
                                onConfirm={confirmModal.onConfirm}
                                confirmText={confirmModal.confirmText}
                                cancelText={confirmModal.cancelText}
                            />
                            <Modal show={showPreviewErrorModal} onHide={() => setShowPreviewErrorModal(false)} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Property Info Required</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Please fill in the <strong>Property Information</strong> before previewing the chatbot.
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={() => setShowPreviewErrorModal(false)}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            {showPublishReminder && (
                                <PublishReminder
                                    onClose={() => setShowPublishReminder(false)}
                                    isNeedPublish={isNeedPublish}
                                    setConfirmModal={setConfirmModal}
                                    confirmPublish={confirmPublish}
                                    setActiveTab={setActiveTab}
                                    setShouldLoadQna={setShouldLoadQna}
                                />
                            )}

                            {
                                showInfoImage && (
                                    <InfoImage
                                    buttonName={buttonName}
                                        show={showInfoImage}
                                        onHide={() => setShowInfoImage(false)}
                                    />
                                )
                            }

                        </>
                    )

            }

            {/* Widget Key Modal — rendered in parent so it survives PropertyInfo remount */}
            {widgetKeyModal.show && widgetKeyModal.rawKey && (
                <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.7)", zIndex: 9999, pointerEvents: "none" }}>
                    <div className="modal-dialog modal-dialog-centered modal-lg" style={{ zIndex: 10000, pointerEvents: "auto" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title"><i className="bi bi-key me-2"></i>Widget Key Generated</h5>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-warning mb-3" role="alert">
                                    <i className="bi bi-exclamation-triangle me-2"></i>
                                    <strong>Please save this key securely.</strong> It will not be shown again.
                                </div>

                                {/* Step 1: Raw Widget Key */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold"><i className="bi bi-1-circle me-1"></i> Your Widget Key</label>
                                    <div className="p-3 bg-light rounded border">
                                        <code className="text-break" style={{ fontSize: "13px", wordBreak: "break-all" }}>
                                            {widgetKeyModal.rawKey}
                                        </code>
                                    </div>
                                    <div className="mt-2 text-end">
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            type="button"
                                            onClick={() => {
                                                navigator.clipboard.writeText(widgetKeyModal.rawKey);
                                                toast.success("Widget key copied to clipboard!");
                                            }}
                                        >
                                            <i className="bi bi-clipboard me-1"></i> Copy Key
                                        </button>
                                    </div>
                                </div>

                                {/* Step 2: Embed Code */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold"><i className="bi bi-2-circle me-1"></i> Your Embed Code</label>
                                    <p className="text-muted mb-2" style={{ fontSize: "13px" }}>
                                        Paste this script tag into your website's HTML, just before the closing <code>&lt;/body&gt;</code> tag. No additional div or link tags are required.
                                    </p>
                                    <div className="p-3 bg-light rounded border" style={{ fontSize: "13px" }}>
                                        <pre className="mb-0" style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
{`<script src="${getSetting('chatbotBaseUrl')}/hotel-chatbot.iife.js?hotelId=${encodeURIComponent(resolvedPropertyId)}&widgetKey=${encodeURIComponent(widgetKeyModal.rawKey)}"></script>`}
                                        </pre>
                                    </div>
                                    <div className="mt-2 text-end">
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            type="button"
                                            onClick={() => {
                                                const code = `<script src="${getSetting('chatbotBaseUrl')}/hotel-chatbot.iife.js?hotelId=${encodeURIComponent(resolvedPropertyId)}&widgetKey=${encodeURIComponent(widgetKeyModal.rawKey)}"></script>`;
                                                navigator.clipboard.writeText(code);
                                                toast.success("Embed code copied to clipboard!");
                                            }}
                                        >
                                            <i className="bi bi-clipboard me-1"></i> Copy Embed Code
                                        </button>
                                    </div>
                                </div>

                                {/* Step 3: Allowed Domains Reminder */}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold"><i className="bi bi-3-circle me-1"></i> Set Up Allowed Domains</label>
                                    <p className="text-muted mb-1" style={{ fontSize: "13px" }}>
                                        For the chatbot to work on your website, you <strong>must</strong> add your website domain(s) to the <strong>Allowed Domains</strong> list in <strong>Property Information</strong>.
                                    </p>
                                    <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                                        For example, if your hotel website is <code>www.myhotel.com</code>, add <code>myhotel.com</code> or <code>*.myhotel.com</code> (to include all subdomains).
                                    </p>
                                </div>

                                <div className="alert alert-info mb-0" role="alert" style={{ fontSize: "13px" }}>
                                    <i className="bi bi-info-circle me-2"></i>
                                    You can also find the embed code in the <strong>Chatbot Script</strong> tab.
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={() => setWidgetKeyModal({ show: false, rawKey: "" })}
                                >
                                    I've Saved My Key — Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </>

    );
};

export default ChatbotFAQ;
